import { Logo } from '@urbantxt/logos';
import React from 'react';
import classes from './AuthFormHeader.module.scss';

interface IProps {
  children?: React.ReactNode;
}

function AuthFormHeader({ children = undefined }: IProps) {
  return (
    <div className={classes.header}>
      <div className={classes.logoWrap}>
        <Logo />
      </div>
      {children}
    </div>
  );
}

export default AuthFormHeader;
